// Fonte: UConjSocio.pas (1.729 linhas) — CRUD cônjuge/sócio (tipo 2 — Cliente Comércio)
// Tabela: Conjuge_Socio (32 colunas)
import React, { useState, useEffect, useCallback } from 'react';
import { Table, Button, Form, Modal, Spinner, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import {
  listarConjugesSocios,
  inserirConjugeSocio,
  atualizarConjugeSocio,
  excluirConjugeSocio,
} from '~/Services/Service';
import moment from 'moment';
import aplicarMascara from '../components/mascaras';

var TIPO_CS = [
  { value: 'C', label: 'Cônjuge/Rep. Legal' },
  { value: 'S', label: 'Sócio' },
  { value: 'J', label: 'Cônjuge do Sócio' },
  { value: 'O', label: 'Outros' },
  { value: 'P', label: 'Procurador' },
  { value: 'N', label: 'Cônjuge do Procurador' },
  { value: 'F', label: 'De Fato' },
];

var SEXO = [
  { value: 'M', label: 'Masculino' },
  { value: 'F', label: 'Feminino' },
];

var ESTADO_CIVIL = [
  { value: 'T', label: 'Solteiro(a)' },
  { value: 'C', label: 'Casado(a)' },
  { value: 'P', label: 'Separado(a)' },
  { value: 'S', label: 'Divorciado(a)' },
  { value: 'E', label: 'Desquitado(a)' },
  { value: 'J', label: 'Amasiado(a)' },
  { value: 'D', label: 'Viúvo(a)' },
  { value: 'V', label: 'Convivente' },
  { value: 'U', label: 'União Estável' },
  { value: 'B', label: 'Outros' },
];

// Fonte: Conjuge_Socio — todos os campos do Delphi (UConjSocio.pas)
var VAZIO = {
  nome: '', tipo: 'C', cpf: '', rg: '', sexo: '', estado_civil: '',
  data_nasc: '', profissao: '', nascionalidade: '', endereco: '',
  bairro: '', cep: '', codigo_cidade: '', ordem: '',
  fone_com: '', fone_res: '', celular: '', email: '',
  naturalidade: '', dt_casorio: '', org_emissor: '', data_exp: '',
  tabeliao: '', cnh: '', orgao_emissor_cnh: '',
  pro_livro: '', pro_folha: '', pro_data: '', registro_antenupcial: '',
};

var val = function(v) { return v !== null && v !== undefined ? v : ''; };

var TabConjugeSocio = function(_ref) {
  var ge = _ref.ge;
  var codigo = _ref.codigo;

  var [lista, setLista] = useState([]);
  var [loading, setLoading] = useState(false);
  var [showModal, setShowModal] = useState(false);
  var [editando, setEditando] = useState(null);
  var [form, setForm] = useState(VAZIO);
  var [salvando, setSalvando] = useState(false);
  var [showExcluir, setShowExcluir] = useState(null);

  var carregar = useCallback(function() {
    if (!ge || !codigo) return;
    setLoading(true);
    listarConjugesSocios(ge, codigo)
      .then(function(resp) {
        setLista(Array.isArray(resp) ? resp : []);
      })
      .catch(function() { toast.error('Erro ao carregar cônjuges/sócios'); })
      .finally(function() { setLoading(false); });
  }, [ge, codigo]);

  useEffect(function() { carregar(); }, [carregar]);

  var handleNovo = function() {
    setEditando(null);
    setForm({ ...VAZIO });
    setShowModal(true);
  };

  var handleEditar = function(item) {
    setEditando(item);
    setForm({
      nome: val(item.nome),
      tipo: val(item.tipo) || 'C',
      cpf: val(item.cpf),
      rg: val(item.rg),
      sexo: val(item.sexo),
      estado_civil: val(item.estado_civil),
      data_nasc: item.data_nasc ? moment(item.data_nasc).format('YYYY-MM-DD') : '',
      profissao: val(item.profissao),
      nascionalidade: val(item.nascionalidade),
      endereco: val(item.endereco),
      bairro: val(item.bairro),
      cep: val(item.cep),
      codigo_cidade: val(item.codigo_cidade),
      ordem: val(item.ordem),
      fone_com: val(item.fone_com),
      fone_res: val(item.fone_res),
      celular: val(item.celular),
      email: val(item.email),
      naturalidade: val(item.naturalidade),
      dt_casorio: item.dt_casorio ? moment(item.dt_casorio).format('YYYY-MM-DD') : '',
      org_emissor: val(item.org_emissor),
      data_exp: item.data_exp ? moment(item.data_exp).format('YYYY-MM-DD') : '',
      tabeliao: val(item.tabeliao),
      cnh: val(item.cnh),
      orgao_emissor_cnh: val(item.orgao_emissor_cnh),
      pro_livro: val(item.pro_livro),
      pro_folha: val(item.pro_folha),
      pro_data: item.pro_data ? moment(item.pro_data).format('YYYY-MM-DD') : '',
      registro_antenupcial: val(item.registro_antenupcial),
    });
    setShowModal(true);
  };

  var handleSalvar = function() {
    if (!form.nome) { toast.warning('Informe o nome'); return; }
    if (!form.tipo) { toast.warning('Informe o tipo (Cônjuge/Sócio)'); return; }
    if (form.tipo === 'P') {
      if (!form.pro_livro) { toast.warning('Informe o Livro da procuração'); return; }
      if (!form.pro_folha) { toast.warning('Informe a Folha da procuração'); return; }
      if (!form.pro_data) { toast.warning('Informe a Data da procuração'); return; }
    }
    setSalvando(true);
    var payload = { ...form };
    if (editando) {
      payload.codigo = editando.codigo;
    }
    var fn = editando
      ? atualizarConjugeSocio(ge, codigo, payload)
      : inserirConjugeSocio(ge, codigo, payload);
    fn
      .then(function() {
        toast.success('Cônjuge/Sócio salvo!');
        setShowModal(false);
        carregar();
      })
      .catch(function() { toast.error('Erro ao salvar cônjuge/sócio'); })
      .finally(function() { setSalvando(false); });
  };

  var handleExcluir = function() {
    excluirConjugeSocio(ge, codigo, { codigo: showExcluir.codigo })
      .then(function() {
        toast.success('Registro excluído!');
        setShowExcluir(null);
        carregar();
      })
      .catch(function() { toast.error('Erro ao excluir'); });
  };

  var handleChange = function(e) {
    var campo = e.target.name;
    var valor = e.target.value;
    setForm(function(f) { return { ...f, [campo]: valor }; });
  };

  return (
    <div className="contas-tab-content">
      <div className="d-flex justify-content-end mb-2">
        <Button size="sm" variant="primary" onClick={handleNovo}>+ Incluir</Button>
      </div>
      {loading ? (
        <div className="text-center py-3"><Spinner animation="border" /></div>
      ) : (
        <Table size="sm" bordered className="contas-sub-grid">
          <thead>
            <tr>
              <th>Ord.</th>
              <th>Nome</th>
              <th>Tipo</th>
              <th>CPF</th>
              <th>RG</th>
              <th>Sexo</th>
              <th>Email</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {lista.length === 0 ? (
              <tr><td colSpan={8} className="text-center text-muted">Nenhum cônjuge/sócio</td></tr>
            ) : (
              lista.map(function(item) {
                return (
                  <tr key={item.codigo}>
                    <td>{item.ordem}</td>
                    <td>{item.nome}</td>
                    <td>{(TIPO_CS.find(function(t) { return t.value === item.tipo; }) || { label: item.tipo }).label}</td>
                    <td>{val(item.cpf) || '-'}</td>
                    <td>{val(item.rg) || '-'}</td>
                    <td>{val(item.sexo) || '-'}</td>
                    <td>{val(item.email) || '-'}</td>
                    <td>
                      <Button size="sm" variant="outline-primary" className="mr-1" onClick={function() { handleEditar(item); }}>Editar</Button>
                      <Button size="sm" variant="outline-danger" onClick={function() { setShowExcluir(item); }}>Excluir</Button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      )}

      <Modal show={showModal} onHide={function() { setShowModal(false); }} size="xl">
        <Modal.Header closeButton className="contas-modal-header">
          <Modal.Title>{editando ? 'Editar Cônjuge/Sócio' : 'Incluir Cônjuge/Sócio'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={1}>
              <Form.Group>
                <Form.Label className="small">Ordem</Form.Label>
                <Form.Control type="number" size="sm" name="ordem" value={form.ordem} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label className="small">Nome *</Form.Label>
                <Form.Control type="text" size="sm" name="nome" value={form.nome} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label className="small">Tipo *</Form.Label>
                <Select
                  options={TIPO_CS}
                  value={TIPO_CS.find(function(t) { return t.value === form.tipo; }) || null}
                  onChange={function(opt) { setForm(function(f) { return { ...f, tipo: opt ? opt.value : '' }; }); }}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">CPF/CNPJ</Form.Label>
                <Form.Control type="text" size="sm" name="cpf" value={aplicarMascara(form.cpf, 'cpf')} onChange={e => { const v = String(e.target.value).toUpperCase().replace(/[^A-Z0-9]/g, ''); setForm(f => ({ ...f, cpf: v })); }} maxLength={18} />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label className="small">RG</Form.Label>
                <Form.Control type="text" size="sm" name="rg" value={form.rg} onChange={handleChange} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={2}>
              <Form.Group>
                <Form.Label className="small">Sexo</Form.Label>
                <Select
                  options={SEXO}
                  isClearable
                  value={SEXO.find(function(s) { return s.value === form.sexo; }) || null}
                  onChange={function(opt) { setForm(function(f) { return { ...f, sexo: opt ? opt.value : '' }; }); }}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Estado Civil</Form.Label>
                <Select
                  options={ESTADO_CIVIL}
                  isClearable
                  value={ESTADO_CIVIL.find(function(e) { return e.value === form.estado_civil; }) || null}
                  onChange={function(opt) { setForm(function(f) { return { ...f, estado_civil: opt ? opt.value : '' }; }); }}
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label className="small">Dt. Nascimento</Form.Label>
                <Form.Control type="date" size="sm" name="data_nasc" value={form.data_nasc} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Profissão/Ramo</Form.Label>
                <Form.Control type="number" size="sm" name="profissao" value={form.profissao} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label className="small">Órgão Emissor</Form.Label>
                <Form.Control type="text" size="sm" name="org_emissor" value={form.org_emissor} onChange={handleChange} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={2}>
              <Form.Group>
                <Form.Label className="small">Dt. Expedição</Form.Label>
                <Form.Control type="date" size="sm" name="data_exp" value={form.data_exp} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Nacionalidade</Form.Label>
                <Form.Control type="text" size="sm" name="nascionalidade" value={form.nascionalidade} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Naturalidade</Form.Label>
                <Form.Control type="text" size="sm" name="naturalidade" value={form.naturalidade} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label className="small">Dt. Casamento</Form.Label>
                <Form.Control type="date" size="sm" name="dt_casorio" value={form.dt_casorio} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label className="small">Tabelião</Form.Label>
                <Form.Control type="text" size="sm" name="tabeliao" value={form.tabeliao} onChange={handleChange} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Form.Group>
                <Form.Label className="small">Endereço</Form.Label>
                <Form.Control type="text" size="sm" name="endereco" value={form.endereco} onChange={handleChange} maxLength={40} />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label className="small">Bairro</Form.Label>
                <Form.Control type="text" size="sm" name="bairro" value={form.bairro} onChange={handleChange} maxLength={20} />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label className="small">CEP</Form.Label>
                <Form.Control type="text" size="sm" name="cep" value={aplicarMascara(form.cep, 'cep')} onChange={function(e) { var v = String(e.target.value).replace(/\D/g, ''); setForm(function(f) { return { ...f, cep: v }; }); }} maxLength={9} />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label className="small">Email</Form.Label>
                <Form.Control type="email" size="sm" name="email" value={form.email} onChange={handleChange} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Fone Comercial</Form.Label>
                <Form.Control type="text" size="sm" name="fone_com" value={aplicarMascara(form.fone_com, 'fone')} onChange={function(e) { var v = String(e.target.value).replace(/\D/g, ''); setForm(function(f) { return { ...f, fone_com: v }; }); }} maxLength={14} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Fone Residencial</Form.Label>
                <Form.Control type="text" size="sm" name="fone_res" value={aplicarMascara(form.fone_res, 'fone')} onChange={function(e) { var v = String(e.target.value).replace(/\D/g, ''); setForm(function(f) { return { ...f, fone_res: v }; }); }} maxLength={14} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Celular</Form.Label>
                <Form.Control type="text" size="sm" name="celular" value={aplicarMascara(form.celular, 'celular')} onChange={function(e) { var v = String(e.target.value).replace(/\D/g, ''); setForm(function(f) { return { ...f, celular: v }; }); }} maxLength={15} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">CNH</Form.Label>
                <Form.Control type="text" size="sm" name="cnh" value={form.cnh} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Órgão Emissor CNH</Form.Label>
                <Form.Control type="text" size="sm" name="orgao_emissor_cnh" value={form.orgao_emissor_cnh} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Registro Antenupcial</Form.Label>
                <Form.Control type="text" size="sm" name="registro_antenupcial" value={form.registro_antenupcial} onChange={handleChange} />
              </Form.Group>
            </Col>
          </Row>
          {form.tipo === 'P' && (
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Livro *</Form.Label>
                <Form.Control type="text" size="sm" name="pro_livro" value={form.pro_livro} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Folha *</Form.Label>
                <Form.Control type="text" size="sm" name="pro_folha" value={form.pro_folha} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Data Procuração *</Form.Label>
                <Form.Control type="date" size="sm" name="pro_data" value={form.pro_data} onChange={handleChange} />
              </Form.Group>
            </Col>
          </Row>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={function() { setShowModal(false); }}>Cancelar</Button>
          <Button variant="success" onClick={handleSalvar} disabled={salvando}>
            {salvando ? <Spinner animation="border" size="sm" /> : 'Gravar'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={!!showExcluir} onHide={function() { setShowExcluir(null); }}>
        <Modal.Header closeButton className="contas-modal-header"><Modal.Title>Confirmar Exclusão</Modal.Title></Modal.Header>
        <Modal.Body>Deseja excluir <strong>{showExcluir && showExcluir.nome}</strong>?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={function() { setShowExcluir(null); }}>Não</Button>
          <Button variant="danger" onClick={handleExcluir}>Excluir</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TabConjugeSocio;
